export default "__VITE_ASSET__BUtLEAe3__"